import { GsFormSchema } from '../../../components';
import { GsStructBorderRadius, GsStructTextAlignment } from '../../../models';
import { DEFAULT_CONFIG } from '../../../services/config/default.config';
import { HORIZONTAL_ALIGNMENT_SCHEMA } from './alignment.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { DISPLAY_MODE_SCHEMA } from './../basics/display-mode.schema';
import { SWIPER_WITH_GRID_SCHEMA_FIELDS } from './../basics/swiper.schema';
import { SPACING_SCHEMA } from './spacing.schema';

export const CALENDAR_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...HORIZONTAL_ALIGNMENT_SCHEMA,
    ...SPACING_SCHEMA,
    ...SWIPER_WITH_GRID_SCHEMA_FIELDS,
    ...DISPLAY_MODE_SCHEMA,
    {
      formControlName: 'showFilterButton',
      label: 'components.calendar.schema.showFilterButton',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showButton',
      label: 'components.calendar.schema.showButton',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showDateInTitle',
      label: 'components.calendar.schema.showDateInTitle',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showCountInFilter',
      label: 'components.calendar.schema.showCountInFilter',
      type: 'checkbox',
      default: false
    },
    {
      formControlName: 'showCalendarIcon',
      label: 'components.calendar.schema.showCalendarIcon',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showShortDescription',
      label: 'components.calendar.schema.showShortDescription',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'emptyMessage',
      label: 'components.calendar.schema.emptyMessage',
      type: 'text',
      default: ''
    },
    {
      formControlName: 'itemTextAlignment',
      label: 'schema.alignment.text.name',
      type: 'select',
      valueType: 'string',
      default: 'left',
      groupingName: 'components.calendar.schema.text.name',
      options: [
        { text: 'schema.alignment.text.left', value: GsStructTextAlignment.left },
        { text: 'schema.alignment.text.center', value: GsStructTextAlignment.center },
        { text: 'schema.alignment.text.right', value: GsStructTextAlignment.right },
        { text: 'schema.alignment.text.justify', value: GsStructTextAlignment.justify }
      ]
    },
    {
      formControlName: 'shortenItemTitles',
      label: 'components.calendar.schema.text.shortenItemTitles.label',
      type: 'checkbox',
      groupingName: 'components.calendar.schema.text.name',
      description: 'components.calendar.schema.text.shortenItemTitles.description',
      default: true
    },
    {
      formControlName: 'showPhotos',
      label: 'components.calendar.schema.showPhotos',
      type: 'checkbox',
      groupingName: 'components.calendar.schema.showPhotos',
      default: true
    },
    {
      formControlName: 'itemZoomOnHover',
      label: 'components.image.schema.zoomOnHover',
      type: 'checkbox',
      default: false,
      groupingName: 'components.calendar.schema.showPhotos'
    },
    {
      formControlName: 'itemImageHeight',
      label: 'schema.items.itemImageHeight',
      type: 'number',
      groupingName: 'components.calendar.schema.showPhotos',
      isResponsive: true,
      default: { default: 200 },
      if: {
        args: [{ formControlName: 'showPhotos', value: true }]
      }
    },
    {
      formControlName: 'borderRadiusImage',
      label: 'components.calendar.schema.borderRadiusImage',
      type: 'select',
      valueType: 'number',
      groupingName: 'components.calendar.schema.showPhotos',
      default: GsStructBorderRadius.none,
      options: [
        { text: 'schema.border.radius.none', value: GsStructBorderRadius.none },
        { text: 'schema.border.radius.small', value: GsStructBorderRadius.sm },
        { text: 'schema.border.radius.regular', value: GsStructBorderRadius.regular },
        { text: 'schema.border.radius.medium', value: GsStructBorderRadius.md },
        { text: 'schema.border.radius.large', value: GsStructBorderRadius.lg },
        { text: 'schema.border.radius.xlarge', value: GsStructBorderRadius.xl },
        { text: 'schema.border.radius.xxlarge', value: GsStructBorderRadius.xxl },
        { text: 'schema.border.radius.xxxlarge', value: GsStructBorderRadius.xxxl },
        { text: 'schema.border.radius.full', value: GsStructBorderRadius.full }
      ],
      if: {
        args: [{ formControlName: 'showPhotos', value: true }]
      }
    },
    {
      formControlName: 'buttons',
      label: 'components.calendar.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    }
  ]
};
